import React, {useEffect} from 'react'
import { fetchAllSCoupons, scouponsSelector } from '../../api/sCouponSlice'
import {fetchAllBrands, brandSelector} from '../../api/brandSlice'

import {  useDispatch, useSelector } from 'react-redux';
import Loader from '../../shared/loader'
import Brand from './scoupon'
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import {MdCardGiftcard} from 'react-icons/md'
// import ViewMore from './viewMore'

export default function Index() {


    const dispatch = useDispatch()

    const { sAllCoupons } = useSelector(scouponsSelector)
    const { brands, loading } = useSelector(brandSelector)


    useEffect(()=>{
        dispatch(fetchAllSCoupons())
        dispatch(fetchAllBrands())
    }, [dispatch])


    
   
    return (
       
        <div className='container md:px-0 px-9 md:py-12 py-4  mx-auto  md:w-4/5  lg:w-3/5 block'style={{minHeight:"70vh"}}>
                <h2 className='md:text-[24px] text-[18px] '>E-Vouchers</h2>
            <hr/>
            <div className='flex flex-wrap md:mt-10 mt-4  '>
            {
                  brands.map((item, i)=>{

                    let arrLength = sAllCoupons && sAllCoupons.filter((it)=>{
                        return it?.brand?._id === item._id
                    })
                
                    console.log({arrLength});

                    return <>                   
                    { 
                        arrLength && arrLength.length > 0 && <div  className="my-3 md:my-5  md:mx-3 mx-3 md:w-[255px] w-[144px] border-white md:rounded-3xl rounded-xl  z-80 md:shadow-lg shadow-xl" >
                           
                           <Fade duration={2000}>
                            <Link className=" " to={`/socialcoupon/${item._id}`}>
                    <div className='' > 

                    {/* <MdCardGiftcard style={{fontSize:"5rem"}} className="mx-auto d-block text-warning" /> */}
                     {
                     item?.image? <img src={item?.image }  className="md:my-[24px] my-[4px] md:h-[140px] h-[80px] object-cover w-full "  alt="imglogo" />
                      : 
                      <span className="md:my-[24px] my-[4px] md:h-[140px] h-[80px] object-cover w-full " >
                         <MdCardGiftcard className="voucher text-center"/>&nbsp;  
                         </span>                    
                    }
                      
  

                   {/* <hr/> */}
               
                      <h6 className="bg-[#9a4c9d] text-center md:rounded-b-3xl rounded-b-xl  text-white md:pt-3 mb-0 text-[14px] mt-[5px] md:h-12 h-6 " >{item.name}</h6>

                    </div>
                    </Link>
                        </Fade>

                    </div>
                    }
                    </>

                  })
              }
              </div>
      
      {/* <ViewMore />  */}

     
        
        </div>
       
    )
}
